<template>
  <div>
    <span class="cursor-pointer" @click="dialog_ativo = true;buscarDetalhamento();">
      {{ Helpers.formatarValor(qtde_dias_ruptura) }} dias
    </span>

    <SysDialog v-model="dialog_ativo" titulo="Detalhamento das Rupturas" ocultar-acoes :largura="1000">
      <div class="mt-n3 mb-1">
        <div class="font-14">
          <span class="font-weight-bold">Período analisado: </span>
          <span>{{ getNomeMeses(props.mes) }} de {{ props.ano }}</span>
        </div>

        <div class="d-flex align-center font-14">
          <span class="font-weight-bold mr-1">Produto: </span>
          <div class="d-flex align-center">
            {{ props.idproduto }} - {{ props.descricao_produto }}
            <DetalhesProduto :produto="{ id_grupo: props.id_grupo, id_filial: props.filial, id_produto: props.idproduto, produto_eh_combinacao: props.produto_eh_combinacao}" />
          </div>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :items="rupturas"
        hide-default-footer
        class="font-resp-tabela"
        :height="350"
        :items-per-page="-1"
        fixed-header
      >
        <template #item.numero_dia="{ item }">
          {{  rupturas.indexOf(item) + 1 }}
        </template>

        <template #item.estoque="{ item }">
          {{  Helpers.formatarValor(item.estoque) }}
        </template>

        <template #item.media_venda_diario="{ item }">
          {{  Helpers.formatarValor(item.media_venda_diario) }}
        </template>

        <template #item.saldo_grupo="{ item }">
          {{  Helpers.formatarValor(item.saldo_grupo) }}
        </template>
      </v-data-table>
    </SysDialog>
  </div>
</template>

<script setup>
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import api from "@/api/api";
import {logout, nomeMeses} from "@/helpers";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";

const props = defineProps({
  id_grupo: Number,
  filial: Number,
  idproduto: String,
  descricao_produto: String,
  produto_eh_combinacao: Boolean,
  qtde_dias_ruptura: Number,
  ano: Number,
  mes: Number,
});

const headers = [
  { text: 'Nº dia', value: 'numero_dia' },
  { text: 'Filial', value: 'filial' },
  { text: 'Data', value: 'data' },
  { text: 'Estoque', value: 'estoque' },
  { text: 'Média Diária', value: 'media_venda_diario' },
  { text: 'Estoque Grupo', value: 'saldo_grupo' },
];

const dialog_ativo = ref(false);

const rupturas = ref([]);

function buscarDetalhamento() {
  const params = {
    id_grupo: props.id_grupo,
    filial: props.filial,
    idproduto: props.idproduto,
    produto_eh_combinacao: props.produto_eh_combinacao ? 'S' : 'N',
    ano: props.ano,
    mes: props.mes,
  };

  api.get('indicadores/perda-venda-por-ruptura/detalhamento/dias-ruptura', {params})
    .then(resposta => {
      rupturas.value = resposta.data.rupturas;
    })
    .catch(logout)
}

function getNomeMeses(mes) {
  return nomeMeses[mes - 1] ? nomeMeses[mes - 1] : '';
}
</script>
